import "./App.css";

import { ConfigProvider } from "antd";
import { Navigate, Route, Routes } from "react-router-dom";
import { WagmiProvider } from "wagmi";
import { base, baseSepolia } from "wagmi/chains";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createWeb3Modal } from "@web3modal/wagmi/react";
import { defaultWagmiConfig } from "@web3modal/wagmi/react/config";

import ComingSoon from "./components/comming-soon";
import Main from "./components/main";
import {
  ENABLE_LANDING_PAGE,
  ENABLE_VESTING_HMC,
  ENABLE_VESTING_VENTURE,
} from "./constants";
import Affiliate from "./pages/apps/afiliate";
import Airdrop from "./pages/apps/airdrop";
import HistoryPage from "./pages/apps/history-page";
import HomePage from "./pages/apps/home-page";
import Marketplace from "./pages/apps/marketplace";
import MarketplaceDetail from "./pages/apps/marketplace/detail";
import P2pLending from "./pages/apps/p2p-lending";
import DetailsP2pLending from "./pages/apps/p2p-lending/details";
import Portfolio from "./pages/apps/porfolio";
import EditProfile from "./pages/apps/porfolio/edit-profile";
import Ranked from "./pages/apps/porfolio/rank";
import VerifyEmail from "./pages/apps/porfolio/verify-email";
import Vesting from "./pages/apps/porfolio/vesting";
import VestingHMC from "./pages/apps/porfolio/vesting-hmc";
import VestingVenture from "./pages/apps/porfolio/vesting-venture";
import Pto from "./pages/apps/pto";
import DetailsPto from "./pages/apps/pto/details";
import StakingList from "./pages/apps/staking";
import StakeDetail from "./pages/apps/staking/details";
import LandingPage from "./pages/landing-page";
import Policy from "./pages/polycy";
import Terms from "./pages/terms";
import { PAGES } from "./routes";

function App() {
  // start config wagmi wallet
  const queryClient = new QueryClient();
  // 1. Get projectId at https://cloud.walletconnect.com
  const projectId =
    process.env.REACT_APP_PROJECT_ID || "5f6c18132c6e21af2b276b34ad0af7ec";
  // 2. Create wagmiConfig
  const metadata = {
    name: "Web3Modal",
    description: "Web3Modal",
    url: "https://web3modal.com", // origin must match your domain & subdomain
    icons: ["https://avatars.githubusercontent.com/u/37784886"],
  };
  // const chains = [baseSepolia] as const;

  const chains =
    process.env.REACT_APP_ENABLE_TESTNET === "true"
      ? ([baseSepolia] as const)
      : ([base] as const);
  // console.log('chains', chains)
  const config = defaultWagmiConfig({
    chains, // required
    projectId, // required
    metadata, // required
    enableInjected: false, // Optional - true by default
    enableWalletConnect: true, // Optional - true by default
    enableEIP6963: true, // Optional - true by default
    enableCoinbase: false, // Optional - true by default
  });
  createWeb3Modal({
    wagmiConfig: config,
    projectId,
    enableAnalytics: true, // Optional - defaults to your Cloud configuration
  });
  // end config wagmi wallet
  return (
    <div className="App">
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#2b79f7",
              },
              components: {
                Popover: {
                  colorBgElevated: "#191B1D",
                },
                Select: {
                  colorBgContainer: "#3b3f4566",
                  colorBgElevated: "#3b3f4566",
                  colorBorder: "#3b3f4566",
                  colorIcon: "#FFFFFF",
                  colorTextPlaceholder: "#FFFFFF",
                  colorText: "#FFFFFF",
                  selectorBg: "#3b3f4566",
                  // optionActiveBg: "#FFFFFF",
                  // optionSelectedBg: "#FFFFFF",
                  // optionSelectedColor: "#FFFFFF",
                },
                Slider: {
                  trackBg: "#00EFFF",
                  railBg: "#FFFFFF",
                  railHoverBg: "#FFFFFF",
                },
                Table: {
                  colorIcon: "#686a6d",
                  colorIconHover: "#fff",
                  colorBgContainer: "#1A1C1E",
                  headerBg: "#191B1D",
                  headerColor: "#ffffff99",
                  borderColor: "#3b3f4566",
                  cellFontSizeSM: 16,
                  fontWeightStrong: 500,
                  colorText: "#FFF",
                },
                Pagination: {
                  itemActiveBg: "#2b79f7",
                  itemSize: 29,
                  itemBg: "#1A1C1E",
                  borderRadius: 8,
                  colorBorder: "#3b3f4566",
                  colorText: "#FFF",
                  colorTextDisabled: "#3b3f4566",
                  fontFamily: "Radio Canada, sans-serif",
                },
              },
            }}
          >
            <Main>
              <Routes>
                {ENABLE_LANDING_PAGE ? (
                  <Route path="/" element={<LandingPage />} />
                ) : null}

                <Route path="/PrivacyPolicy" element={<Policy />} />
                <Route path="/Term" element={<Terms />} />
                <Route path={PAGES.HOME} element={<HomePage />} />
                <Route path={PAGES.P2P_LENDING} element={<P2pLending />} />
                <Route
                  path={PAGES.P2P_LENDING_DETAIL}
                  element={<DetailsP2pLending />}
                />
                <Route path={PAGES.STAKING} element={<StakingList />} />
                <Route path={PAGES.STAKING_DETAIL} element={<StakeDetail />} />
                <Route path={PAGES.ACCOUNT} element={<Portfolio />} />
                <Route
                  path={PAGES.ACCOUNT_EDIT_PROFILE}
                  element={<EditProfile />}
                />
                <Route
                  path={PAGES.ACCOUNT_VERIFY_EMAIL}
                  element={<VerifyEmail />}
                />
                <Route path={PAGES.VESTING} element={<Vesting />} />

                {ENABLE_VESTING_HMC ? (
                  <Route path={PAGES.VESTING_HMC} element={<VestingHMC />} />
                ) : null}

                {ENABLE_VESTING_VENTURE ? (
                  <Route
                    path={PAGES.VESTING_VENTURE}
                    element={<VestingVenture />}
                  />
                ) : null}

                <Route path={PAGES.PTO} element={<Pto />} />
                <Route path={PAGES.PAGE_PTO_DETAIL} element={<DetailsPto />} />
                <Route path={PAGES.MARKETPLACE} element={<Marketplace />} />
                <Route
                  path={PAGES.MARKETPLACE_DETAIL}
                  element={<MarketplaceDetail />}
                />
                <Route path={PAGES.AIRDROP} element={<Airdrop />} />
                <Route path={PAGES.AFFILIATES} element={<Affiliate />} />
                <Route path={PAGES.RANK} element={<Ranked />} />
                <Route path={PAGES.HISTORY} element={<HistoryPage />} />
                <Route path="/apps/coming-soon" element={<ComingSoon />} />
                {/* <Route path='*' element={<Navigate to='/' replace />} /> */}
              </Routes>
            </Main>
          </ConfigProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </div>
  );
}

export default App;
